import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { CSSTransitionGroup } from 'react-transition-group';
import NavigateDownArrow from 'react-material-icons/icons/navigation/expand-more';
import DownloadIcon from 'react-material-icons/icons/file/file-download';
import LinkIcon from 'react-material-icons/icons/content/link';
import { formatPrice } from '@chama/utils/functions/currency';
import Spinner from '../Spinner';
import OrderTable from '../OrderTable';
import './index.css';

const propTypes = {
  id: PropTypes.string.isRequired,
  orders: PropTypes.array.isRequired,
  dealer: PropTypes.object.isRequired,
  total: PropTypes.number.isRequired,
  balance: PropTypes.number.isRequired,
  monthName: PropTypes.string.isRequired,
  startDay: PropTypes.string.isRequired,
  endDay: PropTypes.string.isRequired,
  year: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
  onPeriodClick: PropTypes.func.isRequired,
  getOrderDetails: PropTypes.func.isRequired,
  fetchMoreOrders: PropTypes.func.isRequired,
  dealerProfitAmount: PropTypes.number.isRequired,
  grossLeadFeeAmount: PropTypes.number.isRequired,
  grossMerchantValueAmount: PropTypes.number.isRequired,
  paidByVouchersAmount: PropTypes.number.isRequired,
  paidOnDeliveryAmount: PropTypes.number.isRequired,
  totalOrderedAmount: PropTypes.number.isRequired,
  analyticsTrack: PropTypes.func.isRequired,
  onInvoiceDownloadClick: PropTypes.func.isRequired,
  onPaymentSlipDownloadClick: PropTypes.func.isRequired,
  onNotaFiscalDownloadClick: PropTypes.func.isRequired,
  isLoadingDownload: PropTypes.bool.isRequired,
};

const spinnerStyle = {
  position: 'absolute',
  right: 0,
  top: 0,
};

class OrderPeriod extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      batchSize: null,
      heightFailed: false,
    };
  }

  componentDidMount() {
    const { offsetHeight } = this.periodHeader;

    this.headerHeght = offsetHeight;
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevState.isOpen && this.state.isOpen) {
      this.animatePeriodOpen();
    }
  }

  componentWillReceiveProps(nextProps) {
    const dealerChanged = this.props.dealer.id !== nextProps.dealer.id;

    if (dealerChanged) {
      this.setState({
        isOpen: false,
        batchSize: null,
        heightFailed: false,
      });
    }
  }

  updateWrapperHeight = () => {
    this.orderTableWrapper.style.height = `${this.detailsWrapper.offsetHeight}px`;
  };

  animatePeriodOpen = () => {
    const self = this;

    this.onOpenTransitionEnd = () => {
      this.orderTableWrapper.style.height = 'auto';
      this.orderTableWrapper.removeEventListener('transitionend', this.onOpenTransitionEnd);
    };

    this.orderTableWrapper.addEventListener('transitionend', this.onOpenTransitionEnd);

    try {
      this.updateWrapperHeight();

      self.setState({ heightFailed: false });
    } catch (e) {
      self.setState({ heightFailed: true });

      throw e;
    }
  };

  animatePeriodClose = () => {
    const self = this;

    this.onCloseTransitionEnd = () => {
      this.setState({ isOpen: false });
      this.orderTableWrapper.removeEventListener('transitionend', this.onCloseTransitionEnd);
    };

    this.orderTableWrapper.addEventListener('transitionend', this.onCloseTransitionEnd);

    try {
      this.updateWrapperHeight();
      setTimeout(() => {
        this.orderTableWrapper.style.height = '0px';

        self.setState({ heightFailed: false });
      }, 100);
    } catch (e) {
      self.setState({ heightFailed: true });

      throw e;
    }
  };

  handleRef = refName => {
    return ref => {
      this[refName] = ref;
    };
  };

  onPeriodClick = () => {
    const { isOpen } = this.state;
    const { onPeriodClick, id } = this.props;

    if (!isOpen) {
      return onPeriodClick(id).then(res => {
        const {
          orders: { list },
        } = res;

        this.setState({ isOpen: true, batchSize: list.length });
      });
    }

    return this.animatePeriodClose();
  };

  renderOrderTable = () => {
    const { isOpen, batchSize } = this.state;
    const {
      dealer,
      getOrderDetails,
      fetchMoreOrders,
      id,
      isLoading,
      total,
      dealerProfitAmount,
      grossLeadFeeAmount,
      grossMerchantValueAmount,
      paidByVouchersAmount,
      paidOnDeliveryAmount,
      analyticsTrack,
      totalOrderedAmount,
      onInvoiceDownloadClick,
      onPaymentSlipDownloadClick,
      onNotaFiscalDownloadClick,
      isLoadingDownload,
    } = this.props;

    if (isOpen) {
      return (
        <div className="OrderPeriod__details" ref={this.handleRef('detailsWrapper')}>
          <div className="OrderPeriod__legal_documents">
            <button
              className="OrderPeriod__document u__normalize_button"
              onClick={onInvoiceDownloadClick}
              disabled={isLoadingDownload}
            >
              <div className="OrderPeriod__document_name">
                <FormattedMessage
                  id="order_history.legal_document.invoice"
                  defaultMessage="Invoice"
                />
                <DownloadIcon className="OrderPeriod__document_icon" />
              </div>
            </button>

            <button
              className="OrderPeriod__document u__normalize_button"
              onClick={onPaymentSlipDownloadClick}
              disabled={isLoadingDownload}
            >
              <div className="OrderPeriod__document_name">
                <FormattedMessage
                  id="order_history.legal_document.payment_slip"
                  defaultMessage="Payment slip"
                />
                <DownloadIcon className="OrderPeriod__document_icon" />
              </div>
            </button>

            <button
              className="OrderPeriod__document u__normalize_button"
              onClick={onNotaFiscalDownloadClick}
              disabled={isLoadingDownload}
            >
              <div className="OrderPeriod__document_name">
                <span>Nota fiscal</span>
                <LinkIcon className="OrderPeriod__document_icon" />
              </div>
            </button>
          </div>

          <OrderTable
            isLoading={isLoading && isOpen}
            orders={this.props.orders}
            dealer={dealer}
            getOrderDetails={getOrderDetails}
            periodId={id}
            fetchMoreOrders={fetchMoreOrders}
            batchSize={batchSize}
            ordersTotal={total}
            dealerProfitAmount={dealerProfitAmount}
            grossLeadFeeAmount={grossLeadFeeAmount}
            grossMerchantValueAmount={grossMerchantValueAmount}
            paidByVouchersAmount={paidByVouchersAmount}
            paidOnDeliveryAmount={paidOnDeliveryAmount}
            totalOrderedAmount={totalOrderedAmount}
            analyticsTrack={analyticsTrack}
          />
        </div>
      );
    }

    return null;
  };

  renderHeaderLoadingSpinner = () => {
    const { isLoading } = this.props;

    if (isLoading) {
      return <Spinner key="header-loading-spinner" size={20} thickness={3} style={spinnerStyle} />;
    }

    return null;
  };

  render() {
    const { isOpen, heightFailed } = this.state;
    const { total, balance, monthName, startDay, year, endDay, isLoading } = this.props;
    const componentClass = classNames('OrderPeriod', {
      'is-open': isOpen,
      'is-loading': isLoading,
    });
    const orderTableWrapperClass = classNames('OrderPeriod__order_table_wrapper', {
      'OrderPeriod__order_table_wrapper--fallback': heightFailed,
    });

    return (
      <div className={componentClass}>
        <div className="OrderPeriod__content">
          <div
            onClick={this.onPeriodClick}
            className="OrderPeriod__overview_header"
            ref={this.handleRef('periodHeader')}
          >
            <div className="OrderPeriod__period_date">
              <NavigateDownArrow className="OrderPeriod__expand_icon" />
              <span className="OrderPeriod__month_label">{monthName}&nbsp;</span>
              <span>
                {startDay} - {endDay}, {year}
              </span>
            </div>
            <div className="OrderPeriod__header_right">
              <span className="OrderPeriod__total_orders">
                <strong>{total}&nbsp;</strong>
                <FormattedMessage id="orders" defaultMessage="ORDERS" />
                <span>&nbsp;|&nbsp;</span>
              </span>
              <div className="OrderPeriod__period_total">
                <span className="OrderPeriod__period_total_label">
                  <FormattedMessage id="order_history.net_result" defaultMessage="Net Result" />
                  <span>: </span>
                </span>
                <span>{formatPrice(balance, true)}</span>
              </div>
              <div className="OrderPeriod__header_loading_wrapper">
                <CSSTransitionGroup
                  className="AdminLayout"
                  component="div"
                  transitionName="CSSTG-fade"
                  transitionEnterTimeout={375}
                  transitionLeaveTimeout={300}
                >
                  {this.renderHeaderLoadingSpinner()}
                </CSSTransitionGroup>
              </div>
            </div>
          </div>
          <div className={orderTableWrapperClass} ref={this.handleRef('orderTableWrapper')}>
            {this.renderOrderTable()}
          </div>
        </div>
      </div>
    );
  }
}

OrderPeriod.propTypes = propTypes;

export default OrderPeriod;



// WEBPACK FOOTER //
// ../ui-components/components/OrderPeriod/index.jsx